import { render, staticRenderFns } from "./CoverPhoto.vue?vue&type=template&id=087219ec"
import script from "./CoverPhoto.vue?vue&type=script&lang=js"
export * from "./CoverPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports